// extracted by mini-css-extract-plugin
export default {"payment-form":"Checkout_payment-form__Wj1V5","form-type":"Checkout_form-type__QAz+4","Errors":"Checkout_Errors__PaQvU"};